import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '@api/api';

export type PatExpiresIn = '30' | '60' | '90' | 'never';

export interface PatTokenMeta {
  id: string;
  name: string;
  hint: string;
  expiresAt: string | null;
  lastUsedAt: string | null;
  createdAt: string;
}

export interface PatCreateResponse extends PatTokenMeta {
  token: string;
}

export interface PatListResponse {
  tokens: PatTokenMeta[];
}

export interface PatCreateRequest {
  name: string;
  expiresIn: PatExpiresIn;
}

export const tokensApi = createApi({
  reducerPath: 'tokensApi',
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    listTokens: builder.query<PatListResponse, void>({
      query: () => ({ url: '/auth/tokens', method: 'GET' }),
    }),
    getToken: builder.query<PatTokenMeta, string>({
      query: id => ({ url: `/auth/tokens/${id}`, method: 'GET' }),
    }),
    createToken: builder.mutation<PatCreateResponse, PatCreateRequest>({
      query: body => ({
        url: '/auth/tokens',
        method: 'POST',
        data: body,
      }),
    }),
    revokeToken: builder.mutation<{ message: string }, string>({
      query: id => ({
        url: `/auth/tokens/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useListTokensQuery,
  useGetTokenQuery,
  useCreateTokenMutation,
  useRevokeTokenMutation,
} = tokensApi;
